
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.953 24.478a4.672 4.672 0 01-3.325-1.377l-4.8-4.8a.912.912 0 00-1.26 0l-4.817 4.818a4.669 4.669 0 01-3.324 1.376h-.942l6.08 6.08a4.864 4.864 0 006.874 0l6.096-6.095-.582-.002zM7.427 7.5a4.67 4.67 0 013.325 1.376l4.816 4.818a.893.893 0 001.261 0l4.8-4.8a4.674 4.674 0 013.324-1.376h.578l-6.096-6.096a4.864 4.864 0 00-6.874 0L6.48 7.502l.947-.002z","fill":"#5FB9AD"}}),_c('path',{attrs:{"d":"M30.572 12.56l-3.684-3.682a.699.699 0 01-.261.052h-1.674c-.874.001-1.712.347-2.331.963l-4.799 4.8a2.306 2.306 0 01-3.258 0L9.748 9.876a3.312 3.312 0 00-2.326-.964H5.37a.699.699 0 01-.247-.05l-3.7 3.699a4.865 4.865 0 000 6.875l3.698 3.702a.696.696 0 01.247-.05h2.06a3.312 3.312 0 002.325-.963l4.817-4.817c.87-.87 2.388-.871 3.258 0l4.799 4.798a3.31 3.31 0 002.33.963h1.675c.09 0 .18.019.262.053l3.683-3.683a4.865 4.865 0 000-6.875l-.005-.003z","fill":"#5FB9AD"}})])
          )
        }
      }
    